module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-flow-04-8d82504cf916f4dd5892dc4c711870b4.png";